
 import nordstorm from "../assests/nordstorm.jpg"
 import jcrew from "../assests/jcrew.jpg"
 import OverStock from "../assests/OverStock.jpg"
 import styles from "./Portfolio.module.css"
 import { AiOutlineHtml5 } from "react-icons/ai"
 import {DiCss3} from "react-icons/di"
 import {IoLogoJavascript} from "react-icons/io"
 import {GrReactjs } from "react-icons/gr"
 import {SiRedux} from "react-icons/si"
 import indeed from "../assests/indeed.jpg"

export const Portfolio = () => {


    return(
<div name="projects" style={{"paddingTop":"50px"}}>

    <h1 >Projects</h1>
<div  className={styles.portfolio}>

<div  className={styles.portfoliodiv}>
<img className={styles.portfolioimage} src={indeed}/>
<h2>Indeed Clone</h2>
<p>Indeed is an worldwide employment website for job listings. With Indeed, you can search millions of jobs online to find the next step in your career</p>
 
<div style={{display:"flex",gap:"5%",marginTop:"20px",marginLeft:"20px"}}>
 
                <AiOutlineHtml5 size={30}/>
                <DiCss3 size={30}/>
                <IoLogoJavascript size={28}/>
                <GrReactjs size={28}/>
                <SiRedux size={28}/>
        
              </div>

 <a href="https://github.com/RavinderTakda/nifty-deer-6877"><button>Github</button></a>
 <a href="https://indeedproject.vercel.app/"> <button  style={{"marginLeft":"30px"}}>Live Site</button> </a>
</div>




<div className={styles.portfoliodiv}>
<img className={styles.portfolioimage} src={nordstorm}/>
<h2>NordStorm Clone</h2>
<p>Nordstrom, Inc. is an American luxury department store chain All the time. Shop online for shoes, clothing, jewelry, dresses, makeup and more from top brands</p>
<div style={{display:"flex",gap:"5%",marginTop:"20px",marginLeft:"20px"}}>
                <AiOutlineHtml5 size={30}/>
                <DiCss3 size={30}/>
                <IoLogoJavascript size={28}/>
                <GrReactjs size={28}/>

              </div>


  <a href="https://github.com/RavinderTakda/scared-note-9891"><button>Github</button></a>
 <a href="https://super-cool-site-by-iamraviamar-gmail-com-c03d2.netlify.app/"><button  style={{"marginLeft":"30px"}}>Live Site</button></a>
</div>

<div  className={styles.portfoliodiv}>
<img className={styles.portfolioimage} src={jcrew}/>
<h2>J.crew Clone</h2>
<p>J.Crew offers an assortment of women's, men's, and children's apparel and accessories, including swimwear denim, dresses, suiting, jewelry, and shoes.</p>
<div style={{display:"flex",gap:"5%",marginTop:"20px",marginLeft:"20px"}}>
                <AiOutlineHtml5 size={30}/>
                <DiCss3 size={30}/>
                <IoLogoJavascript size={28}/>
              

              </div>


<a href="https://github.com/RavinderTakda/J.Crew-Clothes"> <button>Github</button> </a>
<a href="https://warm-kitsune-f7de38.netlify.app/"> <button  style={{"marginLeft":"30px"}}>Live Site</button> </a>
</div>



<div  className={styles.portfoliodiv}>
<img className={styles.portfolioimage} src={OverStock}/>
<h2>Overstock Clone</h2>
<p>Overstock.com, Inc. is an American internet retailer selling primarily furniture headquartered in Midvale, Utah, near Salt Lake City.</p>
 
<div style={{display:"flex",gap:"5%",marginTop:"20px",marginLeft:"20px"}}>
 
                <AiOutlineHtml5 size={30}/>
                <DiCss3 size={30}/>
                <IoLogoJavascript size={28}/>
        
              </div>

 <a href="https://github.com/RavinderTakda/sweltering-zephyr-2369"><button>Github</button></a>
 <a href="https://stirring-cuchufli-fc98a4.netlify.app/">
<button style={{"marginLeft":"30px"}}>Live Site</button></a>
</div>





<div>
    
</div>



</div>

</div>

    )




}